(function () {
    'use strict';

    run.admin.parts.rackootTour = function () {
        const rackoot_data = document.getElementById('rackoot_data');
        if (rackoot_data != null) {
            const show_tour = rackoot_data.dataset.showTour;
            if (show_tour == 'true') {
                const tour = new Shepherd.Tour({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        cancelIcon: {
                            enabled: true
                        },
                        classes: 'shadow-md bg-purple-dark',
                        scrollTo: true
                    }
                });

                // What
                tour.addStep({
                    id: 'step-welcome',
                    text: translations.tour.steps.welcome,
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonBegin,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-what-are-rackoots',
                    text: translations.tour.steps.what,
                    attachTo: {
                        element: '#admin_sidebar',
                        // on: 'bottom'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-rackoots-edit',
                    text: translations.tour.steps.edit,
                    attachTo: {
                        element: '#rackoot_info_panel__data',
                        on: 'bottom'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-rackoots-actions',
                    text: translations.tour.steps.actions,
                    attachTo: {
                        element: '#rackoots_items__actions',
                        on: 'bottom'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                // tour.addStep({
                //     id: 'step-rackoots-share',
                //     text: `You can also share a Rackoot and let other people import it to their account, or simply access the links that you have organized yourself-`,
                //     attachTo: {
                //         element: '#rackoots_items__share',
                //         on: 'bottom'
                //     },
                //     classes: '',
                //     buttons: [{
                //         text: translations.tour.buttonNext,
                //         action: tour.next
                //     }]
                // });

                tour.addStep({
                    id: 'step-rackoots-controls',
                    text: translations.tour.steps.controls,
                    attachTo: {
                        element: '#rackoot__controls_toggler',
                        on: 'top'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-rackoots-shortcuts',
                    text: translations.tour.steps.shortcuts,
                    attachTo: {
                        element: '#shortcout_viewer',
                        on: 'top'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-rackoots-start',
                    text: translations.tour.steps.start,
                    attachTo: {
                        element: '#btn_new_menu',
                        on: 'bottom'
                    },
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonNext,
                        action: tour.next
                    }]
                });

                tour.addStep({
                    id: 'step-rackoots-love',
                    text: translations.tour.steps.love,
                    classes: '',
                    buttons: [{
                        text: translations.tour.buttonStartNow,
                        action: tour.complete
                    }]
                });

                tour.start();
            }
        }
    }
})();